import classNames from 'classnames';
import React, { useContext } from 'react';
import { MaterialIdsType, type IVectorLayerProps } from '@meitu/saas-editor-core/es/version-types';
import { useEditor } from '@/hooks/use-editor';
import { useGlobalWidget } from '@/hooks/use-global-widget';
import { useListenActivePickLayerProps } from '@/hooks/use-listen-layer-props';
import { type ListStyleStruct } from '@/types';
import { ListStyleSelector } from '@/widgets/list-style-selector';
import { VectorPanelContext } from '../../context';
import { Tracker } from '../../utils';
import '@/styles/shared.less';
import { VectorLayer } from '@meitu/saas-editor-core/es/layers/vector-layer';

export const ListStyle: React.FC = () => {
    const { layerId, recordId, isIntl, listStyles } = useContext(VectorPanelContext)!;

    const editor = useEditor();

    const popoverWidgetRef = useGlobalWidget(editor, false);

    const props = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;

        const materialIds = layer.materialIds;
        const textListMaterials = materialIds?.[MaterialIdsType.TEXT_LIST] || [];
        const textListMaterialId = textListMaterials.length > 0 ? textListMaterials[0] : '';

        const layerData = layer.data as IVectorLayerProps;
        const { textInfo } = layerData;

        if (!textInfo) return null;

        return {
            textListMaterialId,
        };
    });

    const textListMaterialId = props ? props.textListMaterialId : '';

    // 矢量图层只能设置基础类型（char类型）的列表样式
    const handleSetListStyle = (data: ListStyleStruct) => {
        if (data.id === textListMaterialId) return;

        editor.getInstance(VectorLayer).applyListText(layerId, data);

        Tracker.setListText({
            recordId,
            stageType: editor.stage.getType(),
            listStyle: data.style,
            isVectorLayer: true,
        });
    };

    const handleCancelListStyle = () => {
        editor.getInstance(VectorLayer).cancelListText(layerId);
    };

    const handleListStyleOpenChange = (visible: boolean) => {
        popoverWidgetRef.current = visible;
    };

    return (
        <div className={classNames('list-style', { intl: isIntl })}>
            <ListStyleSelector
                list={listStyles}
                activeId={textListMaterialId}
                onCancelListStyle={handleCancelListStyle}
                onSetListStyle={handleSetListStyle}
                onOpenChange={handleListStyleOpenChange}
            />
        </div>
    );
};
